import View from './view';
import {VisuallyImpairedGroup} from '../group';
import React from 'react';
import {ReduxWrapperProps} from './model';

export const VisuallyImpairedRadio = View;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ReduxVisuallyImpairedRadio = ({label, input: {onChange, value}, meta, ...props}: ReduxWrapperProps) => (
  <VisuallyImpairedGroup label={label}>
    <VisuallyImpairedRadio {...props} onChange={onChange} value={value} />
  </VisuallyImpairedGroup>
);
